import { t } from "i18next";
import { NavLink } from "react-router-dom";
import MonitoringGrid from "./MonitoringGrid";

export default function MonitoringMenu({onClose}:{onClose: () => void}) {
  return (
    <>
      <div className="flex flex-row items-center px-6">
        <NavLink to={"/monitoring"} onClick={onClose}><div className="text-base font-semibold flex h-14 items-center">{t("monitoring")}</div></NavLink>
      </div>
      <MonitoringGrid onClose={onClose}/>
    </>
  )
} 